import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ProvinceCtx = createContext({});

export function ProvinceProvider({ children }) {
  const [provinces, setProvinces] = useState([]);
  const [selected, setSelected] = useState(() => {
    const s = localStorage.getItem("sine_province");
    return s ? JSON.parse(s) : null;
  });
  const [branding, setBranding] = useState({ slogan: "81 İlden Tek Gerçek", site_name: "SİNE81", site_subtitle: "HABER | TV" });

  useEffect(() => {
    api.get("/provinces")
      .then((r) => {
        setProvinces(r.data);
        if (!selected && r.data.length) {
          const def = r.data.find((p) => p.slug === "istanbul") || r.data[0];
          setSelected(def);
          localStorage.setItem("sine_province", JSON.stringify(def));
        }
      })
      .catch(() => {});
    api.get("/settings/branding").then((r) => r.data && setBranding(r.data)).catch(() => {});
  }, []);

  const choose = (p) => {
    setSelected(p);
    localStorage.setItem("sine_province", JSON.stringify(p));
  };

  return (
    <ProvinceCtx.Provider value={{ provinces, selected, choose, branding }}>
      {children}
    </ProvinceCtx.Provider>
  );
}

export const useProvince = () => useContext(ProvinceCtx);
